/**
 * studio-shop D4 — the bag button (`shop-bag-button`): the bag's icon with how
 * many items it holds. It opens the bag: the drawer, on a page that places the
 * bag (`shop-bag`), else the `/shop/bag` page (the Prints mockup's header bag
 * button and its bag). Made for a header row, so it takes its own width.
 */
import { definePiece } from '../../contract/define';

export const contract = definePiece({
  name: 'shop-bag-button',
  description: "The bag button: the bag's icon with how many items it holds; opens the page's bag, or the bag page.",
  placeable: true,
  options: {},
  parts: {
    button: { description: 'The button that opens the bag, named with how many items it holds.', required: true },
    count: { description: 'How many items the bag holds; hidden while it is empty.', required: false },
  },
  actions: {
    open: { description: "Opens the bag: the page's drawer when the page places the bag, else the bag page.", args: [] },
  },
  events: {},
});

/** What the bag button knows. */
export interface ShopBagButtonState {
  /** How many items the bag holds, every quantity added up. */
  readonly count: number;
  /** The button's name: "Bag, empty", "Bag, 1 item", "Bag, 3 items". */
  readonly label: string;
  /**
   * False while the shop lists nothing and the bag is empty: the page then shows no bag at all, since a studio's
   * page shows only what it has, and a drawing draws nothing.
   */
  readonly shown: boolean;
}

/** What a drawing can ask the bag button to do. */
export interface ShopBagButtonActions {
  /** Opens the bag. */
  readonly open: () => void;
}

/** The bag button reports nothing to its host. */
export type ShopBagButtonEvents = Record<string, never>;
